import { useCallback, FC } from 'react';

import { CustomerHeaderView } from 'page/CustomerPage/components/CustomerHeaderView';
import { useListStore, useRegistrationStore } from 'page/CustomerPage/hooks';

export const CustomerHeader: FC = () => {
  const { openModal } = useRegistrationStore();
  const { searchValue, changeSearchValue, changeCustomerStatus } =
    useListStore();

  /**
   * 顧客情報の登録ボタンをクリックしたときの処理
   */
  const handleClickRegistration = () => {
    openModal();
  };

  /**
   * 検索フィールドを変更したときの処理
   * @param searchField ユーザが入力した検索フィールドの値
   */
  const handleSearchValueChange = useCallback(
    (value: string) => {
      changeSearchValue(value);
    },
    [changeSearchValue],
  );

  /**
   * ステータスセレクターを変更したときの処理
   * @param status ユーザが選択したステータスセレクターの値
   */
  const handleSelectStatus = useCallback(
    (status: string) => {
      changeCustomerStatus(status);
    },
    [changeCustomerStatus],
  );

  return (
    <CustomerHeaderView
      searchValue={searchValue}
      handleSearchValueChange={handleSearchValueChange}
      handleClickRegistration={handleClickRegistration}
      handleSelectStatus={handleSelectStatus}
    />
  );
};
